import { iconUrl } from '../components/Icon';

// Icons are rasterised once at this size and scaled when drawn
const RASTER_PX = 64;

const images = new Map();
const tinted = new Map();

const loadImage = (name) => {
  if (!images.has(name)) {
    const img = new Image();
    img.src = iconUrl(name);
    images.set(name, img);
  }
  return images.get(name);
};

// Start loading icons the canvas will draw, so they are ready for the first frames
export const preloadCanvasIcons = (names) => names.forEach(loadImage);

/**
 * public/icons/<name>.svg painted in `color`, as a canvas to pass to drawImage,
 * or null while the file is still loading.
 */
export const getCanvasIcon = (name, color) => {
  const key = `${name}|${color}`;
  if (tinted.has(key)) return tinted.get(key);

  const img = loadImage(name);
  if (!img.complete || !img.naturalWidth) return null;

  const canvas = document.createElement('canvas');
  canvas.width = RASTER_PX;
  canvas.height = RASTER_PX;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, RASTER_PX, RASTER_PX);
  ctx.globalCompositeOperation = 'source-in';
  ctx.fillStyle = color;
  ctx.fillRect(0, 0, RASTER_PX, RASTER_PX);
  tinted.set(key, canvas);
  return canvas;
};
